import React from 'react'
import {useState, useEffect, useCallback} from 'react'
import { 
  Input,
  Spinner,
  IconButton,
  Typography,
  Progress,
  Menu,
  MenuHandler,
  MenuList,
  MenuItem,
  Tooltip
} from '@material-tailwind/react';
import { ArrowPathIcon, ChevronLeftIcon, ChevronRightIcon, ChevronDoubleLeftIcon, ChevronDoubleRightIcon, CircleStackIcon } from '@heroicons/react/24/outline';
import { FunnelIcon } from '@heroicons/react/24/outline';
import Dust20Card from '../Cards/Dust20Card';
import { v4 as uuidv4 } from 'uuid';
import { getMarketplaceData } from '../../util/api';
import { debounce } from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import toast, { Toaster } from 'react-hot-toast';
import {
  useNavigate,
  useLocation
} from "react-router-dom";
import { useTranslation } from 'react-i18next';

import dotPoolImg from '../../assets/imgs/dot-pool.png';
import dotSwapImg from '../../assets/imgs/dot-swap.png';
import dotBotImg from '../../assets/imgs/dot-bot.png';

export default function Dust20Marketplace({handleActivity}) {
  const wallet = useSelector(state => state.wallet);
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [iframeLoaded, setIframeLoaded] = useState(false);

  const handleIframeLoad = () => {
    setIframeLoaded(true);
    setLoading(false);
  };
  return (
    <div className="text-white w-full flex flex-col justify-center items-center mt-3">
      <div className="flex md:flex-row flex-col gap-3 items-center md:mt-10 mt-3">
        <div className="flex flex-col bg-customGray rounded-lg p-3 gap-2">
          <img src={dotSwapImg} alt="dotSwap" className="md:w-[400px] md:h-[300px] w-[280px] h-[200px] rounded-md" />
          <div className="flex flex-row justify-center items-center text-white bg-primary hover:bg-primary-hover font-bold sm:text-[20px] text-[18px] rounded-md p-2 cursor-pointer" onClick={() => window.open('http://dotswap.app/universe/swap', '_blank')}>{t('Swap')}</div>
        </div>
        <div className="flex flex-col bg-customGray rounded-lg p-3 gap-2">
          <img src={dotPoolImg} alt="dotPool" className="md:w-[400px] md:h-[300px] w-[280px] h-[200px] rounded-md" />
          <div className="flex flex-row justify-center items-center text-white bg-primary hover:bg-primary-hover font-bold sm:text-[20px] text-[18px] rounded-md p-2 cursor-pointer" onClick={() => window.open('http://dotswap.app/universe/pools', '_blank')}>{t('Liquidity | DEFI')}</div>
        </div>
        <div className="flex flex-col bg-customGray rounded-lg p-3 gap-2">
          <img src={dotBotImg} alt="dotBot" className="md:w-[400px] md:h-[300px] w-[280px] h-[200px] rounded-md" />
          <div className="flex flex-row justify-center items-center text-white bg-primary hover:bg-primary-hover font-bold sm:text-[20px] text-[18px] rounded-md p-2 cursor-pointer" onClick={() => window.open('https://t.me/dotswap_trade_bot', '_blank')}>{t('Trade and Copy Trade')}</div>
        </div>
      </div>
    </div>
  )
}
